import LoadingSpinner from 'components/loading-spinner';
import Paper from 'components/paper';
import { useSiteSettingsState } from 'views/site-settings/context/site-settings-context';
import RecommendedProducts from './components/recommended-products';
import SiloBuffer from './components/silo-buffer';
import SiloCapacity from './components/silo-capacity';
import SiloManagement from './components/silo-management';
import SiteInformation from './components/site-information';
import { Box } from '@mui/material';

type Props = {};

const InventorySiloManagement: React.FC<Props> = ({}) => {
  const {
    access,
    featuresQuery: { isLoading },
  } = useSiteSettingsState();

  return (
    <>
      <Box gap={40}>
        <Paper transparent sx={{ color: 'white', borderTopLeftRadius: { xs: 0, md: 0 } }}>
          <SiloCapacity />
          {isLoading ? (
            <LoadingSpinner />
          ) : (
            <>
              {access.hasSiloBufferAccess && <SiloBuffer />}
              {access.hasProductAccess && <RecommendedProducts />}
            </>
          )}
          <SiloManagement />
          <SiteInformation />
        </Paper>
      </Box>
    </>
  );
};

export default InventorySiloManagement;
